export default __webpack_public_path__ + "static/media/V340MANE1.790e923d.pdf";